import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=ec1f0044&scoped=true&"
import script from "./HeaderInfo.vue?vue&type=script&lang=ts&"
export * from "./HeaderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=ec1f0044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1f0044",
  null
  
)

export default component.exports